<template lang="pug">
  include ../../../../../views/desktop/shared/iconMixins.pug
  .background
    .background-video.a-box-xs-4x3.a-box-sm-12x5
      .a-box-content.video-banner(v-show="!fallbackToImage")
        video(:src="videoSrc" autoplay muted loop playsinline ref="video")

      .a-box-content.image-banner(v-show="fallbackToImage")
        ImgBox(:mediaId="media.imageId")

      .a-box-content.control
        .row.full-height
          .fixed-width-tweak-upper.full-height
            .welcome-control.xs-12.full-height.board
              .welcome-text.upper.bold.color-white.text-center
                .xs-f-small.lg-f-xlarge.max-at-tweak welcome back,
                #guest-name.xs-f-xgrande.lg-f-xxxgrande.max-at-tweak {{guestName}}
              .video-control
                button.video-toggle.btn-reset.color-white.upper.bold(v-if="!fallbackToImage" @click="toggleVideo")
                  .play-video(v-show="videoPaused")
                    span.icon-play.bold
                    span.text play 

                  .pause-video(v-show="!videoPaused")
                    +icon-pause(class="icon-pause")
                    span.text pause

</template>

<script>
  import { mapState } from 'vuex';
  import ImgBox from '../../../imgBox';
  
  export default {
    name: "Welcome",

    components: {
      ImgBox,
    },

    data() {
      return {
        media: {
          video: {
            mobile: 'https://d3ewrnwdcmri66.cloudfront.net/videos/HOMEPAGE+VIDEO+-+MOBILE+v5.mp4',
            desktop: 'https://d3ewrnwdcmri66.cloudfront.net/videos/HOMEPAGE+VIDEO+-+DESKTOP+v5.mp4',
          },

          imageId: 6187, 
        },
        fallbackToImage: false,
        videoPaused: false,
      }
    },

    inject: ['getObjProperty'],

    computed: {
      ...mapState('customer', ['info']),

      guestName() {
        return this.getObjProperty(this.info, 'first_name') || 'Beautiful';
      },

      videoSrc() {
        const breakpoint = this.getObjProperty(this.$root, 'windowData.breakpoint');
        return this.media.video[breakpoint] || this.media.video['desktop'];
      }
    },

    methods: {
      toggleVideo() {
        if(!this.videoPaused) {
          this.pauseVideo();
        } else {
          this.playVideo();
        }
        this.videoPaused = !this.videoPaused;
      },

      pauseVideo() {
        return this.$refs.video.pause();
      },

      playVideo() {
        return this.$refs.video.play();
      },
    },

    mounted() {
      this.$nextTick(()=> {
        this.$refs.video.onerror = () => {
          this.fallbackToImage = true;
        };

        this.$refs.video.playbackRate = 0.75;
      });
    }
  }
</script>

<style scoped lang="stylus">
  .background
    .background-video
      video
        width 100%
      .welcome-control
        display flex
        flex-direction column

        .video-control
          flex-grow 1
          display flex
          flex-direction column
          justify-content flex-end
          align-items flex-end

          .video-toggle
            padding 0 1em
            border-radius 0.5em
            text-shadow 0 2px 4px rgba(0, 0, 0, 0.5)

            &:hover
            &:focus
              background-color rgba(0, 0, 0, 0.25)
              color color-white

            .play-video
            .pause-video
              display flex
              align-items center

              > .text
                margin 0.7em 0

              .icon-play
              .icon-pause
                margin-right 0.5em

              .icon-play
                &:before
                  font-size 1.2em
                  font-weight 700
                
        .welcome-text
          margin-top 8.75%
          width 100%
          text-shadow 0 2px 4px rgba(0, 0, 0, 0.5)

  @media mq-tablet-plus
    .welcome-control
      padding-bottom 1em !important

  @media mq-desktop-md-plus
    .background-video
      .video-toggle
        bottom 2.5%

      .welcome-text
        > * + *  
          margin-top 0.3em

</style>
